(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-send-prize/render"] = factory(require("VueDemi"), require("FEGORender"));
	else
		root["/fego/component/common-send-prize/render"] = factory(root["VueDemi"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__5322__) => {
return 